<template>
  <div class="auto-complete-background">
    <div class="help-wrapper">
      <svg class="help-icon" @click="clickHelp"
           version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
           width="24px" height="24px" viewBox="0 0 400 400" style="enable-background:new 0 0 400 400;" xml:space="preserve">
        <g>
          <path d="M199.996,91.382c-35.176,0-63.789,28.616-63.789,63.793c0,7.243,5.871,13.115,13.113,13.115
            c7.246,0,13.117-5.873,13.117-13.115c0-20.71,16.848-37.562,37.559-37.562c20.719,0,37.566,16.852,37.566,37.562
            c0,20.714-16.849,37.566-37.566,37.566c-7.242,0-13.113,5.873-13.113,13.114v45.684c0,7.243,5.871,13.115,13.113,13.115
            s13.117-5.872,13.117-13.115v-33.938c28.905-6.064,50.68-31.746,50.68-62.427C263.793,119.998,235.176,91.382,199.996,91.382z"/>
          <path d="M200.004,273.738c-9.086,0-16.465,7.371-16.465,16.462s7.379,16.465,16.465,16.465c9.094,0,16.457-7.374,16.457-16.465
            S209.098,273.738,200.004,273.738z"/>
        </g>
      </svg>

      <transition name="help-info">
        <div class="help-info-wrapper" v-if="showHelp">
          <p class="title">도움말</p>

          <div class="line"></div>

          <p class="description">아이템 추가하기</p>
          <p class="description">- 박스에서 검색하여 추가해주세요!</p>
          <p class="description">순서 변경하기</p>
          <p class="description">- 아이템을 클릭하고 변경할 위치의 아이템을 한번 더 클릭하면 위치를 변경할 수 있어요!</p>
        </div>
      </transition>
    </div>

    <div class="auto-complete-wrapper"
         @mouseover="isSelecting = true"
         @mouseout="isSelecting = false"
         v-click-outside="onFocusOut"
         :style="{ left: useHelp ? '32px' : 0, zIndex: depth }">

      <div class="input-box" :class="{ 'error': isError }">
        <div class="select-item"
             v-for="(item, index) in selectItems"
             :key="item.id" @click="() => { swapItem(index) }" :class="{ active: swap.base === index }">
          <span>{{ item[trackName] }}</span>
          <img :src="resources.removeIcon" class="remove-icon" @click.stop="() => { removeItem(index) }"/>
        </div>

        <div v-show="isEnabledInput" ref="input"
             class="auto-complete-input"
             @input="doSearching"
             @focus="onFocus"
             @blur="onFocusOut"
             contenteditable="true">
        </div>

        <div class="drop-down">
          <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
               width="10px" height="10px" viewBox="0 0 255 255" style="enable-background:new 0 0 255 255;" xml:space="preserve">
            <g>
              <g id="arrow-drop-down">
                <polygon points="0,63.75 127.5,191.25 255,63.75"/>
              </g>
            </g>
          </svg>
        </div>
      </div>

      <div class="auto-complete" v-if="show">
        <div class="shape">
          <div v-for="(item, index) in result"
              :key="index"
              class="item-wrapper"
              @click.stop="() => { selectAutoComplete(item) }">
            <p class="item">{{ item[trackName] }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import _ from 'lodash';
import axios from 'axios';
import RemoveButton from '@/assets/icons/remove-button.svg';

Vue.directive('click-outside', {
  bind: (el, binding, vnode) => {
    el.clickOutsideEvent = (event) => {
      // here I check that click was outside the el and his childrens
      if (!(el === event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind: (el) => {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  },
});

export default {
  name: 'LayoutAsyncMultipleAutoComplete',
  props: {
    apiUrl: {
      type: String,
      isRequired: true,
    },
    trackName: {
      type: String,
      isRequired: true,
    },
    httpOptions: {
      type: Object,
      default: () => ({}),
    },
    trackBy: {
      type: String,
      default: 'id',
    },
    type: {
      type: String,
      default: 'text',
    },
    value: {
      type: Array,
    },
    placeHolder: {
      type: String,
      default: '',
    },
    regex: {
      type: String,
      default: '',
    },
    useHelp: {
      type: Boolean,
      default: true,
    },
    min: {
      type: Number,
      default: 1,
    },
    max: {
      type: Number,
      default: 5,
    },
    depth: {
      type: Number,
      default: 1,
    },
  },
  watch: {
    selectItems(value) {
      this.$emit('input', value.map(item => item[this.trackBy]));
    },
  },
  computed: {
    isEnabledInput() {
      return this.max > this.selectItems.length;
    },

    isError() {
      return this.selectItems.length < this.min;
    },
  },
  methods: {
    async doSearching(text) {
      this.stringValue = text.target.innerText;

      const result = await axios.get(`${this.apiUrl}?text=${this.stringValue}&page=${this.page}&per_page=${this.perPage}`, this.httpOptions);

      this.result = result.data.result.rows;
      this.showAutoComplete();
    },

    async onFocus() {
      await this.doSearching(this.stringValue);
    },

    onFocusOut() {
      if (!this.isSelecting) {
        this.hideAutoComplete();
      }
    },

    clickHelp() {
      this.showHelp = !this.showHelp;
    },

    showAutoComplete() {
      this.show = true;
    },

    hideAutoComplete() {
      this.show = false;
    },

    selectAutoComplete(item) {
      this.selectItems.push(item);
      this.$refs.input.innerHTML = '';
      this.hideAutoComplete();
      this.swap.mode = false;
      this.swap.base = null;
    },

    removeItem(index) {
      this.selectItems.splice(index, 1);
      this.swap.mode = false;
      this.swap.base = null;
    },

    swapItem(index) {
      if (this.selectItems.length < 2) return;
      if (this.swap.mode && this.swap.base === index) return;

      if (!this.swap.mode) this.swap.base = index;
      else {
        const temp = _.cloneDeep(this.selectItems[this.swap.base]);
        this.selectItems[this.swap.base] = this.selectItems[index];
        this.selectItems[index] = temp;

        this.$emit('input', this.selectItems.map(item => item[this.trackBy]));

        this.swap.base = null;
      }

      this.swap.mode = !this.swap.mode;
    },
  },
  data() {
    return {
      result: [],

      show: false,
      stringValue: '',
      selectItems: [],
      isSelecting: false,

      page: 1,
      perPage: 9999,

      resources: {
        removeIcon: RemoveButton,
      },

      swap: {
        mode: false,
        base: null,
      },

      showHelp: false,
    };
  },
  async created() {
    const result = await axios.get(`${this.apiUrl}`, this.httpOptions);

    this.selectItems = this.value.map((select) => {
      let selectItem = null;

      result.data.result.rows.some((item) => {
        const base = parseInt(item[this.trackBy], 10);
        const target = parseInt(select, 10);

        if (base === target) {
          selectItem = item;
        }

        return base === target;
      });

      return selectItem;
    });
  },
};
</script>

<style lang="scss" scoped>
.auto-complete-background {
  position: relative;

  width: 100%;
  height: 50px;

  .help-wrapper {
    height: 100%;

    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;

    .help-info-enter-active, .help-info-leave-active {
      transition: all 0.2s ease-in-out;
    }

    .help-info-enter {
      opacity: 0;
      transform: translateY(-20px);
    }

    .help-info-leave-to {
      opacity: 0;
      transform: translateY(-20px);
    }

    .help-icon {
      background-color: rgb(255, 255, 255);

      border: rgba(102, 102, 102, 0.1) 1px solid;
      border-radius: 15px;

      box-shadow: 0 4px 24px rgba(0, 0, 0, 0.04);

      fill: rgb(155, 155, 155);

      cursor: pointer;
    }

    .help-icon:hover {
      fill: rgba(100, 200, 255, 0.8);
    }

    .help-info-wrapper {
      position: absolute;

      top: 50px;
      left: 2px;

      z-index: 10;

      display: inline-block;
      background: rgb(255, 255, 255);
      width: 300px;
      height: 200px;
      margin: 0 auto 10px;

      border: 1px solid rgba(0, 0, 0, 0.1);
      border-radius: 5px;
      padding: 10px;

      .line {
        width: 100%;
        height: 1px;

        background-color: rgba(0, 0, 0, 0.1);

        margin-top: 10px;
        margin-bottom: 10px;
      }

      .title {
        font-size: 18px;
        color: rgba(0, 0, 0, 0.8);

        margin: 0;
      }

      .description {
        font-size: 12px;
        color: rgba(0, 0, 0, 1);

        font-weight: 200;
      }
    }

    .help-info-wrapper:after {
      content: '';
      position: absolute;
      border-bottom: 10px solid rgb(255, 255, 255);
      border-right: 5px solid transparent;
      border-left: 5px solid transparent;
      top: -9px;
      left: 5px;
    }

    .help-info-wrapper:before {
      content: '';
      position: absolute;
      border-bottom: 10px solid rgba(0, 0, 0, 0.2);
      border-right: 5px solid transparent;
      border-left: 5px solid transparent;
      top: -11px;
      left: 5px;
    }
  }

  .auto-complete-wrapper {
    position: absolute;

    left: 0;
    top: 0;

    width: auto;
    height: auto;

    z-index: 20;

    min-width: 500px;

    padding-top: 5px;
    padding-bottom: 5px;

    .input {
      padding-left: 15px;

      box-sizing: border-box;
    }

    .input-box {
      position: relative;

      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      align-content: center;

      width: auto;
      height: 40px;

      border: rgba(180, 180, 180, 0.4) 1px solid;
      border-radius: 5px;

      background-color: rgb(255, 255, 255);

      padding-right: 30px;

      .auto-complete-input {
        width: 100%;

        display: inline-block;
        outline: none;
        border: none;

        margin-left: 10px;

        white-space: nowrap;

        min-width: 100px;
      }

      .drop-down {
        position: absolute;
        right: 10px;
      }

      .select-item {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        align-content: center;

        width: auto;
        height: 30px;

        padding-left: 10px;
        padding-right: 10px;

        border: rgba(102, 102, 102, 0.3) 1px solid;
        border-radius: 5px;

        margin-left: 5px;

        background-color: rgba(100, 200, 255, 0.8);

        cursor: pointer;

        span {
          width: 100%;
          white-space: nowrap;
        }

        .remove-icon {
          width: 10px;
          height: 10px;

          margin-left: 10px;

          cursor: pointer;
        }
      }

      .active {
        background-color: rgba(100, 200, 255, 0.3);
      }

    }

    .input-box:hover {
      border: rgba(180, 180, 180, 0.8) 1px solid;
    }

    .input-box:focus {
      border: rgba(100, 200, 255, 0.8) 1px solid;
      box-shadow: rgba(0, 0, 0, 0.1) 1px 1px 5px 1px;
    }
    .error {
      color: rgb(159, 85, 80);
      background: rgb(253, 246, 246);
      border: rgb(217, 162, 181) 1px solid;
    }

    .auto-complete {
      width: 100%;
      height: auto;

      z-index: 200;

      .shape {
        width: 100%;
        height: auto;
        max-height: 300px;
        overflow-y: scroll;
        background: rgb(255, 255, 255);
        box-shadow: 0 12px 32px rgba(0,0,0,0.3);

        .item-wrapper {
          width: 100%;
          box-sizing: border-box;
          padding: 0 16px;
          cursor: pointer;
          background: rgb(255, 255, 255);
          &:hover {
            background: rgb(41, 155, 252);
            .item {
              color: #ffffff;
            }
          }
          .item {
            position: relative;
            box-sizing: border-box;
            width: 100%;
            height: 100%;
            font-size: 14px;
            padding: 12px 16px;
            margin: 0;
            color: #666666;
            border-bottom: 1px solid rgba(0, 0, 0, 0.08);
          }
        }
      }
    }

    .invisible-background {
      position: fixed;
      z-index: 99;
      top: 0;
      left: 0;
      width: 100%;
      height: 100vh;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/LayoutAsyncMultipleAutoComplete.vue